var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20712 0.944856C1.49371 0.658274 1.95835 0.658274 2.24493 0.944856L11.051 9.75093C11.3376 10.0375 11.3376 10.5022 11.051 10.7887C10.7644 11.0753 10.2998 11.0753 10.0132 10.7887L1.20712 1.98266C0.920542 1.69608 0.920542 1.23144 1.20712 0.944856Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.051 0.944856C10.7644 0.658274 10.2998 0.658274 10.0132 0.944856L1.20712 9.75093C0.920542 10.0375 0.920542 10.5022 1.20712 10.7887C1.49371 11.0753 1.95835 11.0753 2.24493 10.7887L11.051 1.98266C11.3376 1.69608 11.3376 1.23144 11.051 0.944856Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_336)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.258789,
    y: -0.00396729,
    width: 11.7414,
    height: 11.7414,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.10decbd819adbb6bdffdad8b0d00e009.svg";
export { ForwardRef as ReactComponent };